import type { IdlAccounts } from '@coral-xyz/anchor'
import { PublicKey } from '@solana/web3.js'
import idlJson from '../idl/forum.json'
import type { Forum } from '../idl/forum'

// The JSON import widens every literal to `string`/`number[]`; the generated .ts
// carries the exact literal types Anchor wants. Same bytes, two views of them.
export const FORUM_IDL = idlJson as Forum
export const FORUM_PROGRAM_ID = new PublicKey(FORUM_IDL.address)

/**
 * Account shapes as the *program* defines them, derived from the generated IDL.
 * Add or remove a field in the Rust struct and these types change on the next
 * `chain build`, so any code below that used the old shape stops compiling.
 */
export type PublisherAccount = IdlAccounts<Forum>['publisher']
export type VideoAccount = IdlAccounts<Forum>['video']
export type SubtitleTrackAccount = IdlAccounts<Forum>['subtitleTrack']
export type StorageLocationAccount = IdlAccounts<Forum>['storageLocation']
export type VideoContainerAccount = IdlAccounts<Forum>['videoContainer']
export type VersionRefAccount = IdlAccounts<Forum>['versionRef']
